<div class="modal solid open">
  <div (click)="close()" class="miniClose cancel icon-HamburgerAppClose"></div>
  <div class="title">Move Network Controller</div>
  <div class="subtitle">Move your network controller via provider and location or choose an Allocated IP.</div>
  <div class="icon" style="background-image: url(/assets/svgs/EditNetwork.svg)"></div>
  @if (!hasAllocatedIps) {
    <div class="providerRow">
      <div class="providerField" id="ProviderField">
        <div class="label">
          Network Provider
          <span class="specialnote">Required</span>
        </div>
        <select (change)="providerChanged($event.target.value)" [(ngModel)]="model.provider" id="Providers">
          @for (provider of providers; track provider) {
            <option [value]="provider.type">
              {{ provider.type }}
            </option>
          }
        </select>
      </div>
      <div id="LocationField">
        <div class="label">
          Network Location
          <span class="specialnote">Required</span>
        </div>
        <select [(ngModel)]="model.region" id="NetworkLocationSelect">
          <option [value]="undefined">Select a Region</option>
          @for (region of displayedRegions; track region) {
            <option [value]="region.locationCode">
              {{ region.city }} {{ region.locationCode }}
            </option>
          }
        </select>
      </div>
      <div class="skipBackupField">
        <div class="label">
          Network Backup
          <span class="specialnote">Optional</span>
        </div>
        <div class="checkbox-container">
          <div
            class="checkbox"
            [ngClass]="{ selected: skipBackup }"
            (click)="onSkipBackupChange()"
            id="SkipBackupCheckbox"
          ></div>
          <label class="checkbox-label" (click)="onSkipBackupChange()">Skip backup</label>
        </div>
      </div>
      <div class="warningLabel" style="padding-top: 1.875rem">
        <app-message
          severity="warn"
                text="Please note that you are about to move this network controller to provider {{
                    this.model.provider
                }} and region {{ this.model.region }}."
        ></app-message>
      </div>
    </div>
  }
  <div class="label buttonSwitch row">
    @if (hasAllocatedIps) {
      <app-select-button (click)="dataSelection()" [options]="options" [(ngModel)]="value" optionLabel="label" optionValue="value"></app-select-button>
    }
  </div>

  @if (value=='provider' && hasAllocatedIps) {
    <div class="providerRow">
      <div class="providerField" id="ProviderField">
        <div class="label">
          Network Provider
          <span class="specialnote">Required</span>
        </div>
        <select (change)="providerChanged($event.target.value)" [(ngModel)]="model.provider" id="Providers">
          @for (provider of providers; track provider) {
            <option [value]="provider.type">
              {{ provider.type }}
            </option>
          }
        </select>
      </div>
      <div id="LocationField">
        <div class="label">
          Network Location
          <span class="specialnote">Required</span>
        </div>
        <select [(ngModel)]="model.region" id="NetworkLocationSelect">
          <option [value]="undefined">Select a Region</option>
          @for (region of displayedRegions; track region) {
            <option [value]="region.locationCode">
              {{ region.city }} {{ region.locationCode }}
            </option>
          }
        </select>
      </div>
      <div class="skipBackupField">
        <div class="label">
          Network Backup
          <span class="specialnote">Optional</span>
        </div>
        <div class="checkbox-container">
          <div
            class="checkbox"
            [ngClass]="{ selected: skipBackup }"
            (click)="onSkipBackupChange()"
            id="SkipBackupCheckbox"
          ></div>
          <label class="checkbox-label" (click)="onSkipBackupChange()">Skip backup</label>
        </div>
      </div>
      <div class="warningLabel" style="padding-top: 1.875rem">
        <app-message
          severity="warn"
                text="Please note that you are about to move this network controller to provider {{
                    this.model.provider
                }} and region {{ this.model.region }}."
        ></app-message>
      </div>
    </div>
  }
  @if (value=='ipAddress') {
    <div class="ipRow">
      <div class="ipField" id="IpField">
        <div class="label">
          Allocated IPs
          <span class="specialnote">Required</span>
        </div>
        <select (change)="dataSelection()" [(ngModel)]="selectedIp" id="ips">
          <option [value]="undefined">Select an IP</option>
          @for (ip of allocatedIps; track ip) {
            <option [ngValue]="ip">
              {{ ip.ip }} {{ ip.provider }} {{  ip.region }}
            </option>
          }
        </select>
      </div>
      <div class="skipBackupField">
        <div class="label">
          Network Backup
          <span class="specialnote">Optional</span>
        </div>
        <div class="checkbox-container">
          <div
            class="checkbox"
            [ngClass]="{ selected: skipBackup }"
            (click)="onSkipBackupChange()"
            id="SkipBackupCheckbox"
          ></div>
          <label class="checkbox-label" (click)="onSkipBackupChange()">Skip backup</label>
        </div>
      </div>
    </div>
  }


  <button (click)="moveNetwork()" [disabled]="disableButton" class="save" id="CreateButton">Move</button>
</div>
